<main class="body">
    <div class="content">
        <div>
            <h1>Get medical advice on COVID-19 symptoms</h1>
            <p>To help fight the COVID-19 pandemic, we at Mica Health™ has built a version of its artificial intelligence symptom assessment app specifically for COVID-19, to help assess symptoms and provide guidance on further action.</p>
            <p>This app is free to use.</p>
            <a class="btn btn-primary" href="/assessor">Begin Assessment →</a>
            <br>
        </div>
    </div>
    <div class="content">
        <img src="img/who.svg" class="source_logo">
        <img src="img/cdc.svg" class="source_logo">
        <h3>Based on reliable sources</h3>
        <p>This tool is constantly updated based on official information from the WHO and the latest CDC guidelines.</p>
    </div>
    <div class="content">
        <h3>Our Partners</h3>
        <div>
            <p>Developed in partnership with</p>
            <img src="img/smp.svg" class="sponsor">
        </div>
        <div>
            <p>Sponsored by</p>
            <img src="img/ams.svg" class="sponsor">
        </div>
    </div>
    <div class="content">
        <p>Developed by</p>
        <h1 style="color: #ff3d5c">mica health</h1>
        <a class="btn" href="https://micamd.com" target="_blank">About Mica Health️ →</a>
    </div>
    <div class="content">
        <a href="{tos_url}" target="_blank">Terms of Service</a> | <a href="{pp_url}" target="_blank">Privacy Policy</a>
    </div>
</main>

<script>
    let tos_url = "https://drive.google.com/open?id=16ctFTh6ggV9NkaMRc_idSWUXyIFyC5nZ";
    let pp_url = "https://drive.google.com/open?id=16bx1eM8n1Eyyb06Sd4JLRl_FywQxi1ol";
</script>

<style>
    .body {
        padding-left: 8%;
        padding-right: 8%;
        padding-top: 58px;
        padding-bottom: 24px;
        max-width: 760px;
        margin: 0 auto;
    }

    .content {
        margin-bottom: 76px;
    }

    .btn {
        padding: 12px;
        color: #ff3d5c;
        border: solid 1px #888888;
        border-radius: 50px;
    }

    .btn-primary {
        border: none;
        color: #ffffff;
        background: #ff3d5c;
    }

    .source_logo {
        max-width: 120px;
        max-height: 100px;
        margin-right: 16px;
    }

    .sponsor {
        max-width: 180px;
        max-height: 100px;
        margin-right: 16px;
    }
</style>